// Source: app/scripts/controllers/register-person.js
/**
 * Created by ristes on 20.4.15.
 */




Auction.controller('RegisterPersonController', [
  '$scope',
  '$modal',
  '$filter',
  '$location',
  'toaster',
  'crudService',
  'Messages',
  function ($scope, $modal, $filter, $location, toaster, crudService, Messages) {

    $scope.entity = {};
    $scope.entity.lang = 'sq';
    $scope.entity.individual={};
    $scope.allowCreate = false;

    var service = crudService('individuals', {
      register: {
        method: 'POST',
        url: '/data/rest/registered_users/register_individual'
      },
      checkPersonalNumber: {
        method: 'GET',
        isArray: false,
        url: '/data/rest/registered_users/check_personal_number'
      }
    });

    $scope.response = null;
    $scope.widgetId = null;

    $scope.showCaptcha = true;

    $scope.model = {
//      key: '6LdgoQITAAAAALJEkb87z5eLvsG1NlTZRwDLEznF'
      key: '6LcBx18tAAAAAIRbvC-leQ5rRLDIIuBBUDjVosAx'
    };

    $scope.setResponse = function (response) {
      $scope.response = response;
    };

    $scope.setWidgetId = function (widgetId) {
      $scope.widgetId = widgetId;
    };

    $scope.register = function () {
      var error = false;

      if ($scope.entity.email !== $scope.entity.confirmEmail) {
        toaster.pop('error', $filter('translate')('error'), $filter(
          'translate')('eauction.confirm_email_missmatch'));
        error = true;
      }
      if ($scope.registerPerson.$invalid) {
        toaster.pop('error', $filter('translate')('error'), $filter(
          'translate')('eauction.fill_in_required_fields'));
        error = true;
      }
      if (!$scope.pwStrength || $scope.pwStrength < 20) {
        // console.log('pwStrength');
        // console.log($scope.pwStrength);
        // toaster.pop('error', $filter('translate')('error'), $filter(
        //   'translate')('eauction.weak_password'));
        // error = true;
      }
      if ($scope.entity.password !== $scope.entity.confirmPassword) {
        toaster.pop('error', $filter('translate')('error'), $filter(
          'translate')('eauction.confirm_password_missmatch'));
        error = true;
      }

      if (!error) {
        var entity = {
        username : $scope.entity.username,
        password : $scope.entity.password,
        confirmPassword : $scope.entity.confirmPassword,
        email : $scope.entity.email,
        lang : $scope.entity.lang,
        language : $scope.entity.language,
        disabledTo : $scope.entity.disabledTo,
        phone : $scope.entity.phone,
        title : $scope.entity.title,
        personalNumber : $scope.entity.personalNumber,
        firstName : $scope.entity.firstName,
        lastName : $scope.entity.lastName,
        parentName: $scope.entity.parentName,
        address : $scope.entity.address,
        city : $scope.entity.city,
        dateOfBirth : $scope.entity.dateOfBirth,
        cityOfLivingName : $scope.entity.cityOfLivingName
        };
        console.log('entity');
        console.log($scope.entity);
        console.log(entity);
        service.register(entity
        , function () {
          $location.path("/login").search({
            info: 'eauction.person_registered'
          })
        });
      }

    };

    $scope.checkPersonalNumber = function (personalNumber) {
      service.checkPersonalNumber({personalNumber: personalNumber}, function (data) {
        $scope.allowCreate = data.allowCreate;
        if(data.individual && data.individual.id) {
          if (data.allowCreate) {
            $scope.entity = data.individual;
            $scope.entity.personalNumber = personalNumber;
          }
        }

        if(!data.allowCreate){
          Messages.error('Individual already exists');
        }

        // if(!data.id){
        //
        //   $scope.allowCreate = true;
        //   console.log('in checkPersonalNumber if ' + $scope.allowCreate)
        // }else{
        //   $scope.allowCreate = false;
        //   Messages.error('Individual already exists');
        //   console.log('in checkPersonalNumber else ' + $scope.allowCreate)
        // }
      })
    }


  }
]);
